import React, { useMemo, useCallback } from 'react';
import { Collapse } from './Collapse';
import Icon from '../icon/Icon';
import { acChevronDown, acChevronTop } from 'ac-icon';
import { useCollapse } from '../../hooks/useCollapse';
import classNames from 'classnames';
import { isEmpty } from 'ac-share';
const CollapseWrapper = ({ label, className, contentClassName, labelTextClassName, labelBlockClassName, labelBlockId, children, isOpenInitial, size, collapseChevronPosition, additionalElement, isOpenProp, toggleProp, customIconPath, }) => {
    const [isOpenLocal, toggleCollapse] = useCollapse(isEmpty(isOpenProp) ? isOpenInitial : isOpenProp);
    if (!collapseChevronPosition) {
        collapseChevronPosition = 'start-left';
    }
    const isLeftChevron = collapseChevronPosition === 'center-left' || collapseChevronPosition === 'start-left';
    const isOpen = isEmpty(isOpenProp) ? isOpenLocal : isOpenProp;
    if (!size) {
        size = 'l';
    }
    const getChevronSize = useCallback((newSize) => {
        switch (newSize) {
            case 'xs': {
                return '16px';
            }
            case 's': {
                return '20px';
            }
            case 'm':
            case 'l': {
                return '24px';
            }
            default: {
                return '16px';
            }
        }
    }, []);
    const renderChevron = useMemo(() => {
        let pathO;
        let pathC;
        if (customIconPath) {
            pathO = customIconPath.open;
            pathC = customIconPath.close;
        }
        return (React.createElement("div", { className: 'd-flex' },
            React.createElement(Icon, { className: 'cw-icon-' + collapseChevronPosition.split('-')[1], path: isOpen ? pathO || acChevronTop : pathC || acChevronDown, id: labelBlockId + (isOpen ? 'icon-open' : 'icon-close'), title: isOpen ? 'Свернуть' : 'Развернуть', size: getChevronSize(size) })));
    }, [collapseChevronPosition, customIconPath, getChevronSize, isOpen, labelBlockId, size]);
    return useMemo(() => {
        return (React.createElement("div", { className: className },
            React.createElement("div", { id: labelBlockId, className: classNames('cw-title-wrapper', size, collapseChevronPosition.split('-')[0], labelBlockClassName), onClick: () => {
                    if (toggleProp) {
                        toggleProp(!isOpen);
                    }
                    else {
                        toggleCollapse();
                    }
                } },
                isLeftChevron && renderChevron,
                React.createElement("p", { className: classNames('cw-label', size, labelTextClassName) }, label),
                additionalElement && additionalElement,
                !isLeftChevron && renderChevron),
            React.createElement(Collapse, { isOpen: isEmpty(isOpen) ? isOpen : isOpen, className: contentClassName ? contentClassName : '' }, children)));
    }, [
        className,
        labelBlockId,
        size,
        collapseChevronPosition,
        labelBlockClassName,
        isLeftChevron,
        renderChevron,
        labelTextClassName,
        label,
        additionalElement,
        isOpen,
        contentClassName,
        children,
        toggleProp,
        toggleCollapse,
    ]);
};
export { CollapseWrapper };
//# sourceMappingURL=CollapseWrapper.js.map